import { render, staticRenderFns } from "./moreTW.vue?vue&type=template&id=2b8732ae&lang=pug&"
import script from "./moreTW.vue?vue&type=script&lang=js&"
export * from "./moreTW.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports